<template>
  <div :data-state="data.state" class="input-parent">
    <label for="message" class="label">{{ data.label }}</label>
    <textarea
      ref="myRef"
      name="message"
      :type="data.type"
      v-bind:value="data.text"
      v-on:input="
        updateState({
          event: data.key,
          payload: $event.target.value,
        })
      "
      class="textarea"
    />
    <p class="word-count">
      {{ $t('contact.input_message_char_count') }} {{ data.wordCount }}
    </p>
    <div class="errorWrapper">
      <span class="error-text">{{ data.error }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Message',
  props: ['data', 'updateState'],
};
</script>

<style scoped>
.input-parent {
  margin-bottom: 30px;
}

.textarea {
  font-size: 14px;
  color: #2b4047;
  width: 100%;
  min-height: 100px;
  padding: 26px;
  border: 1px solid #ecf1f2;
  border-radius: 4px;
  outline: 0;
  box-shadow: 0px 1px 3px #00000029;
}

.word-count {
  color: #c8d1d3;
  font-size: 12px;
  padding-left: 12px;
}

/* STATES */
.input-parent[data-state='default'] .textarea {
  border-color: #ecf1f2;
}
.input-parent[data-state='active'] .textarea {
  border-color: #ffdf22;
}
.input-parent[data-state='error'] .textarea {
  border-color: #f15c5e;
}
.input-parent[data-state='default'] .textarea:focus {
  border-color: #ffdf22;
}

.error-text {
  color: #f15c5e;
  font-family: Lato, sans-serif;
}
@media (min-width: 1224px) {
  .input-parent {
    grid-column: 1 / -1;
  }
}
</style>
